import axios from "axios"
import {isRequestError, RequestError} from "../../Model/RequestError";
import {isSimDetails, SimDetails} from "../../Model/Sim/SimDetails";
import {acceptHeader, executeWithErrorResponseHandling, jsonContentTypeHeader} from "../ApiUtilities";
import {joinUrl} from "../../Utilities/UriUtilities";
import {SimDetailsSearch} from "../../Model/Sim/SimDetailsSearch";
import {Reseller} from "../../Types/Reseller";
import {readSessionItem, saveSessionItem} from "../../Utilities/SessionUtilities";
import {COUNTER_API_CALLS} from "../../Service/CounterMetricsProvider";

/**
 * Function will attempt to find a SIM that matches the given search criteria.
 *
 * @param domain Base endpoint for the sales portal backend.
 * @param reseller Currently configured reseller for this instance of the Sales Portal.
 * @param simSearch Information on the SIM we are trying to find.
 */
export const fetchSimDetails = async (
    domain: string,
    reseller: Reseller,
    simSearch: SimDetailsSearch
): Promise<SimDetails | RequestError> => {
    const endpoint = joinUrl(domain, `/${reseller}/sim/verify`)
    const headers = {...acceptHeader(), ...jsonContentTypeHeader()}

    const response = await executeWithErrorResponseHandling<SimDetails>(() =>
        axios.post(endpoint, simSearch, {headers: headers}))

    if (isRequestError(response)) {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/{reseller}/sim/verify", "status": "error"}})
        return response
    } else {
        COUNTER_API_CALLS.emit({severityNumber: 9, severityText: "INFO", body: "", attributes: {"api": "/{reseller}/sim/verify", "status": "success"}})
        saveSessionItem("sim-details", response.data)
        return response.data
    }
}
